import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
} from '@mui/material';
import { listAppointments } from '../../services/appointmentService';
import { useAuth } from '../../contexts/AuthContext';

const PatientAppointmentsModal = ({ open, onClose, patient }) => {
  const { profile } = useAuth();
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAppointments = async () => {
      if (!open || !patient || !profile?.tenant_id) return;
      setLoading(true);
      setError(null);
      try {
        const { data, error } = await listAppointments({
          tenantId: profile.tenant_id,
          patientId: patient.id,
        });
        if (error) throw error;
        setAppointments(data);
      } catch (err) {
        setError('Failed to load appointments.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, [open, patient, profile?.tenant_id]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Appointments for {patient?.first_name} {patient?.last_name}
      </DialogTitle>
      <DialogContent>
        {loading && <Typography>Loading...</Typography>}
        {error && <Alert severity="error">{error}</Alert>}
        {!loading && !error && appointments.length === 0 && (
          <Typography sx={{ mt: 2 }}>No appointments found for this patient.</Typography>
        )}
        {!loading && !error && appointments.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Physician</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {appointments.map((appt) => (
                  <TableRow key={appt.id}>
                    <TableCell>{new Date(appt.scheduled_at).toLocaleString()}</TableCell>
                    <TableCell>{`Dr. ${appt.physician.first_name} ${appt.physician.last_name}`}</TableCell>
                    <TableCell>
                      <Chip label={appt.status} size="small" />
                    </TableCell>
                    <TableCell>{appt.type}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PatientAppointmentsModal;
